export default {
  labelWidth: 120,
  emptyBtn: false,
  submitText: '保存',
  column: [
    {
      label: "主键ID",
      prop: "id",
      display: false,
      rules: [{
        required: true,
        message: "请输入主键ID",
        trigger: "change"
      }]
    },
    {
      label: "小区名称",
      prop: 'communityId',
      type: 'select',
      dicUrl: 'api/base/property/getCommunityTree',
      props: { label: 'roomName', value: 'id' },
      disabled: true,
      maxlength: 100,
      rules: [{
        required: true,
        message: "请输入小区名称",
        trigger: "change"
      }]
    },
    {
      label: "楼栋名称",
      prop: "buildingName",
      disabled: true,
      maxlength: 100,
      rules: [{
        required: true,
        message: "请输入楼栋名称",
        trigger: "change"
      }]
    },
    {
      label: "电梯名称",
      prop: "elevatorName",
      disabled: true,
      maxlength: 100,
      rules: [{
        required: true,
        message: "请输入电梯名称",
        trigger: "change"
      }]
    },
    {
      label: "电梯品牌",
      prop: "brand",
      disabled: true,
      maxlength: 100,
      rules: [{
        required: true,
        message: "请输入品牌",
        trigger: "change"
      }]
    },
    {
      label: "安全负责人",
      prop: "safetyOfficer",
      disabled: true,
      hide: true,
      maxlength: 40,
      rules: [{
        required: true,
        message: "请输入安全员",
        trigger: "change"
      }]
    },
    {
      label: "联系电话",
      prop: "linkPhone",
      disabled: true,
      maxlength: 20,
      rules: [{
        required: true,
        message: "请输入联系电话",
        trigger: "change"
      }]
    },
    {
      label: "告警类型",
      prop: "alarmType",
      disabled: true,
      type: "select",
      dicUrl: '/api/blade-system/dict/dictionary?code=elevator_alarm_type',
      props: {
        label: "dictValue",
        value: "dictKey",
      },
      rules: [{
        required: true,
        message: "请输入警告类型",
        trigger: "change"
      }]
    },
    {
      label: "告警时间",
      prop: "alarmTime",
      disabled: true,
      type: 'datetime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      rules: [{
        required: true,
        message: "请输入警告时间",
        trigger: "change"
      }]
    },
    {
      label: "告警内容",
      prop: "alarmContent",
      disabled: true,
      span:24,
      rules: [{
        required: true,
        message: "请输入警告内容",
        trigger: "change"
      }]
    },
    {
      label: "处理状态",
      prop: "handleFlag",
      type: 'radio',
      span:24,
      dicData: [
        { label: '已处理', value: '1' },
        { label: '未处理', value: '0' },

      ],
      rules: [{
        required: true,
        message: "请选择处理状态",
        trigger: "change"
      }]
    },
    {
      label: "处理结果",
      prop: "handleDesc",
      span:24,
      type: 'textarea',
      rules: [{
        required: true,
        message: "请输入处理内容",
        trigger: "change"
      }]
    },
  ],
 }
